import { CanAccess } from '@modules/common/components/CanAccess';
import {
  getDashboardLink,
  getDashboardRoute,
  trackDashboardEvent,
} from '@modules/dashboard/helpers';
import { useCreateDashboardFromTemplate } from '@modules/dashboard/hooks';
import { LoadingButton } from '@mui/lab';
import {
  DashboardListItemViewFragment,
  PermissionOperation,
  PermissionResource,
} from 'generated/graphql';
import { useNavigate } from 'react-router-dom';
import { useGetUser } from 'v2/core/services/user';

interface UseTemplateButtonProps {
  template: DashboardListItemViewFragment;
}

export const UseTemplateButton = ({ template }: UseTemplateButtonProps) => {
  const { createDashboard, loading } = useCreateDashboardFromTemplate({
    templateID: template.id,
  });

  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const navigate = useNavigate();

  const onClick = async () => {
    const res = await createDashboard();
    const dashboard = res.data?.createDashboardFromTemplate?.dashboard;
    if (!dashboard) {
      return;
    }
    const dashboardRoute = getDashboardRoute(dashboard);
    navigate(dashboardRoute);
    trackDashboardEvent({
      eventName: 'New Dashboard Created From Template',
      dashboardLink: getDashboardLink(dashboard, tenantSlug),
      templateLink: getDashboardLink(template, tenantSlug),
    });
  };

  return (
    <CanAccess
      resource={PermissionResource.Artefact}
      operation={PermissionOperation.Write}
    >
      <LoadingButton loading={loading} onClick={onClick} variant="contained">
        Use This Template
      </LoadingButton>
    </CanAccess>
  );
};
